import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import _isFunction from "lodash/isFunction";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.is-array.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable camelcase */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import exactMath from 'exact-math';
import { Row, Col, Paper, Button, BorrowerExpensesForm, BorrowerExpensesData } from 'components';
import { jsx as ___EmotionJSX } from "@emotion/react";

var BorrowerExpenseTab = function BorrowerExpenseTab(_ref) {
  var _borrower$expenses, _borrower$external_cr, _borrower$external_cr2, _borrower$external_cr3, _borrower$external_cr4, _borrower$incomes$red, _borrower$incomes;

  var borrower = _ref.borrower,
      idNumber = _ref.idNumber,
      onBorrowerChange = _ref.onBorrowerChange,
      margin = _ref.margin;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isEdit = _useState2[0],
      setIsEdit = _useState2[1];

  var borrowerExpenses = borrower === null || borrower === void 0 ? void 0 : (_borrower$expenses = borrower.expenses) === null || _borrower$expenses === void 0 ? void 0 : _borrower$expenses.at(0);
  var totalExternalCreditsMonth = (_borrower$external_cr = borrower === null || borrower === void 0 ? void 0 : (_borrower$external_cr2 = borrower.external_credits) === null || _borrower$external_cr2 === void 0 ? void 0 : _borrower$external_cr2.reduce(function (n, _ref2) {
    var monthly_payment = _ref2.monthly_payment;
    return exactMath.add(Number(n), Number(monthly_payment));
  }, 0)) !== null && _borrower$external_cr !== void 0 ? _borrower$external_cr : 0;
  var totalExternalCreditsAmount = (_borrower$external_cr3 = borrower === null || borrower === void 0 ? void 0 : (_borrower$external_cr4 = borrower.external_credits) === null || _borrower$external_cr4 === void 0 ? void 0 : _borrower$external_cr4.reduce(function (n, _ref3) {
    var amount = _ref3.amount;
    return exactMath.add(Number(n), Number(amount));
  }, 0)) !== null && _borrower$external_cr3 !== void 0 ? _borrower$external_cr3 : 0;
  var totalIncomeAmount = (_borrower$incomes$red = borrower === null || borrower === void 0 ? void 0 : (_borrower$incomes = borrower.incomes) === null || _borrower$incomes === void 0 ? void 0 : _borrower$incomes.reduce(function (n, _ref4) {
    var amount = _ref4.amount;
    return exactMath.add(Number(n), Number(amount));
  }, 0)) !== null && _borrower$incomes$red !== void 0 ? _borrower$incomes$red : 0;

  var handleChange = function handleChange(data) {
    setIsEdit(false);
    _isFunction(onBorrowerChange) && onBorrowerChange([data]);
  };

  return ___EmotionJSX(Row, {
    justify: "space-between",
    align: "center",
    backgroundColor: "white"
  }, ___EmotionJSX(Col, {
    sm: 12
  }, ___EmotionJSX(Paper, {
    header: function header(_ref5) {
      var css = _ref5.css;
      return ___EmotionJSX("div", {
        css: css
      }, ___EmotionJSX("h5", null, "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u0437\u0430 \u0440\u0430\u0437\u0445\u043E\u0434\u0438"), !isEdit && ___EmotionJSX(Button, {
        small: true,
        onClick: function onClick() {
          return setIsEdit(function (prev) {
            return !prev;
          });
        }
      }, "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u0430\u0439"));
    },
    margin: margin !== null && margin !== void 0 ? margin : '0 0 2em 0'
  }, isEdit ? ___EmotionJSX(BorrowerExpensesForm, {
    data: borrowerExpenses,
    idNumber: idNumber,
    onBorrowerChange: handleChange,
    onCancel: function onCancel() {
      return setIsEdit(false);
    }
  }) : ___EmotionJSX(BorrowerExpensesData, {
    totalExternalCreditsMonth: totalExternalCreditsMonth,
    totalExternalCreditsAmount: totalExternalCreditsAmount,
    totalIncomeAmount: totalIncomeAmount,
    data: borrowerExpenses
  }))));
};

BorrowerExpenseTab.propTypes = {
  margin: PropTypes.string,
  borrower: PropTypes.object,
  idNumber: PropTypes.string,
  onBorrowerChange: PropTypes.func
};
export default BorrowerExpenseTab;